import { render, staticRenderFns } from "./BarraNavegacao.vue?vue&type=template&id=3cf9dc6e&scoped=true"
import script from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BarraNavegacao.vue?vue&type=style&index=0&id=3cf9dc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9dc6e",
  null
  
)

export default component.exports